<template>
    <svg :style="style" viewBox="0 0 547.473 841.89" enable-background="new 0 0 547.473 841.89" xml:space="preserve">
        <path :fill="paddleBgColor" d="M540.547,426.504c-16.475-196.541,0-317.752,0-317.752c0-58.496-47.421-105.917-105.918-105.917
            c0,0-168.137,20.508-321.03,0.513C55.103,3.348,7.681,50.769,7.681,109.265c0,0,15.991,165.816,0,317.752
            C1.559,485.19,55.103,532.936,113.599,532.936l60.809,0.206c39.649,9.57,42.042,146.976,20.636,260.283
            c-4.65,24.616,21.205,45.631,47.346,45.631h63.131c26.141,0,52.313-21.527,47.664-46.144
            c-21.406-113.308-19.013-250.713,20.636-260.283l60.809-0.206C493.126,532.423,545.432,484.795,540.547,426.504z"/>
        <text x="50%" y="290" dominant-baseline="middle" text-anchor="middle" font-size="148px" font-weight="700" :fill="paddleTextColor" letter-spacing="-5">{{ paddle }}</text>
        <text v-if="shortcut" x="50%" y="750" dominant-baseline="middle" text-anchor="middle" font-size="96px" font-weight="bold" :fill="paddleTextColor">{{ shortcut }}</text>
    </svg>
</template>

<script>
export default {
    props: {
        paddle: {
            type: String
        },
        width: {
            type: null
        },
        bgColor: {
            type: String
        },
        textColor: {
            type: String
        },
        shortcut: {
            type: String
        }
    },
    computed: {
        style() {
            let style = '';
            if(this.width) style += `width: ${this.width};`
            if(this.height) style += `height: ${this.height};`
            return style != '' ? style : 'width: 80px; height: auto;';
        },
        paddleBgColor() {
            return this.bgColor || '#dddddd'
        },
        paddleTextColor() {
            return this.textColor || '#232323'
        }
    }
}
</script>
